import React from 'react';
import styles from './sort.module.css';

const Sort = ({ all, count }) => {
  return (
    <div className={styles.sort}>
      <div className={styles.column}>
        <p>ÐÑÐµÐ³Ð¾ {all}:</p>
        <span>{count}</span>
      </div>
      {/* <div className={styles.column}>
        <p>Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾:</p>
        <span>Ð´Ð°ÑÐµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ</span>
      </div> */}
    </div>
  );
};

export default Sort;
